import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import Iconify from 'src/components/iconify';
import { useJobCreationContext } from 'src/sections/job2/hooks/use-job-creation-context';
import PropTypes from 'prop-types';

export default function TrackApplicationsDialog({ open, setOpen }) {
  // hooks
  const { jobApplyLink: applyLink } = useJobCreationContext();
  const { enqueueSnackbar } = useSnackbar();

  // states
  const [jobApplyLink, setJobApplyLink] = useState(applyLink);
  const [sourceName, setSourceName] = useState('');
  const [copyButtonClicked, setCopyButtonClicked] = useState(false);

  // functions
  const handleCopyClick = async () => {
    try {
      setCopyButtonClicked(true);
      enqueueSnackbar('Copied');
      await navigator.clipboard.writeText(jobApplyLink);
      setJobApplyLink(jobApplyLink);
      setTimeout(() => {
        setCopyButtonClicked(false);
      }, 2000);
    } catch (err) {
      console.error('Unable to copy link to clipboard:', err);
    }
  };

  const handleLinkChange = event => {
    setJobApplyLink(event.target.value);
  };

  const handleSourceName = event => {
    const source = event.target.value;
    setSourceName(source);

    const updatedLink = new URL(jobApplyLink);
    if (source) {
      updatedLink.searchParams.set(
        'utm_source',
        source.trim().replace(/\s+/g, '-'),
      );
    } else {
      updatedLink.searchParams.delete('utm_source');
    }
    setJobApplyLink(updatedLink.toString());
  };

  // effects
  useEffect(() => {
    setJobApplyLink(applyLink);
  }, [applyLink]);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
      <DialogTitle>
        <Stack direction="row" alignItems="center">
          <Iconify icon="tabler:user" width={32} />
          <Typography variant="h3">Track Applications</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing="20px">
          <Stack spacing="6px">
            <Typography variant="subheading1" fontSize={16}>
              Enter your source name
            </Typography>
            <TextField
              placeholder="Source Name"
              value={sourceName}
              onChange={handleSourceName}
            />
          </Stack>
          <Stack spacing="6px">
            <Typography variant="subheading1" fontSize={16}>
              Job apply link with source name
            </Typography>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{ width: '100%' }}
            >
              <TextField
                fullWidth
                placeholder="https://hireintel.ai/jobpostinglink-software-engineeri..."
                value={jobApplyLink}
                disabled
                onChange={handleLinkChange}
                sx={{
                  width: '500px',
                }}
              />
              <Button
                variant="contained"
                startIcon={
                  !copyButtonClicked && (
                    <Iconify color="white" icon="tabler:copy" />
                  )
                }
                onClick={handleCopyClick}
              >
                {copyButtonClicked ? 'Copied' : 'Copy link'}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

TrackApplicationsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};
